// app/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";

const isBrowser = typeof window !== "undefined";

if (isBrowser) {
  i18n.use(LanguageDetector);
}

i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      "en-US": { translation: en },
      fr: { translation: fr },
      "fr-FR": { translation: fr },
    },
    lng: isBrowser ? undefined : "fr",
    fallbackLng: "fr",
    detection: isBrowser
      ? {
          order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
          ],
        }
      : undefined,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
